import { Routes, RouterModule } from '@angular/router';
import { HomepageComponent } from './homepage/homepage.component';
import { AuthGuard } from './_guard/index';
import { GameComponent } from './game/game.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { ResetPasswordComponent } from './components/users/reset-password/reset-password.component';
import { UserProfileComponent } from './components/users/user-profile/user-profile.component';
import { CompanyProfileComponent } from './components/company/company-profile/company-profile.component';
import { AddGameComponent } from './components/company/add-game/add-game.component';
import { CompanyDashboardComponent } from './components/company/company-dashboard/company-dashboard.component';
import { CompanyStatsComponent } from './components/company/company-stats/company-stats.component';

const APP_ROUTES: Routes = [
    // {
    //     path: '',
    //     component: HomepageComponent
    // },
    {
        path: '',
        component: GameComponent
    }
    //,
    // {
    //     path: 'error',
    //     component: ErrorPageComponent
    // },
    // {
    //     path: 'reset_password/:token',
    //     component: ResetPasswordComponent
    // },
    // {
    //     path: 'profile',
    //     component: UserProfileComponent,
    //     canActivate: [AuthGuard],
    //     data: {
    //         expectedRoles: ['ROLE_USER', 'ROLE_ADMIN']
    //     }
    // },
    // {
    //     path: 'company/profile',
    //     component: CompanyProfileComponent,
    //     canActivate: [AuthGuard],
    //     data: {
    //         expectedRoles: ['ROLE_COMPANY', 'ROLE_ADMIN']
    //     }
    // },
    // {
    //     path: 'company/add-game',
    //     component: AddGameComponent,
    //     canActivate: [AuthGuard],
    //     data: {
    //         expectedRoles: ['ROLE_COMPANY', 'ROLE_ADMIN']
    //     }
    // },
    // {
    //     path: 'company/dashboard',
    //     component: CompanyDashboardComponent,
    //     canActivate: [AuthGuard],
    //     data: {
    //         expectedRoles: ['ROLE_COMPANY', 'ROLE_ADMIN']
    //     }
    // },
    // {
    //     path: 'company/stats/:id',
    //     component: CompanyStatsComponent,
    //     canActivate: [AuthGuard],
    //     data: {
    //         expectedRoles: ['ROLE_COMPANY', 'ROLE_ADMIN']
    //     }
    // }
    ,
    { path: '**', redirectTo: 'error' }
];

export const Routing = RouterModule.forRoot(APP_ROUTES);


// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/app.routing.ts